module.exports = __webpack_public_path__ + "img/alur-pendaftaran-hak-cipta.cf375e3d.png";